import { Box, Dropdown, IconButton, ListItemDecorator, Menu, MenuButton, MenuItem } from "@mui/joy";
import { LogOut, Settings, User2, CircleUser } from "lucide-react";

import { env } from "../../config";

const LOGOUT_URL = `${env.API_ENDPOINT}/v1/auth/external/cognito/logout`;
export default function UserQuickNavigation() {
    const handleOnLogout = () => {
        //window.location.href = "http://localhost:4000/v1/auth/external/cognito/logout";
        window.location.href = LOGOUT_URL;
    };

    return (
        <Box>
            <Dropdown>
                <MenuButton
                    slots={{ root: IconButton }}
                    slotProps={{ root: { variant: "outlined", color: "neutral" } }}
                >
                    <CircleUser size={18} />
                </MenuButton>
                <Menu placement="bottom-end">
                    <MenuItem onClick={handleOnLogout}>
                        <ListItemDecorator>
                            <LogOut size={16} />
                        </ListItemDecorator>{" "}
                        Logout
                    </MenuItem>
                    <MenuItem disabled>
                        <ListItemDecorator>
                            <User2 size={16} />
                        </ListItemDecorator>{" "}
                        Profile
                    </MenuItem>
                    <MenuItem disabled>
                        <ListItemDecorator>
                            <Settings size={16} />
                        </ListItemDecorator>{" "}
                        Customization
                    </MenuItem>
                </Menu>
            </Dropdown>
        </Box>
    );
}
